import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="turbo-modal"
export default class extends Controller {
  static LEAVE_FALLBACK_MS = 400;

  hideModal() {
    const backdrop = this.element.querySelector(".turbo-modal-backdrop-enter");
    const dialog = this.element.querySelector(".turbo-modal-dialog-enter");

    if (
      !backdrop ||
      !dialog ||
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    ) {
      this.#removeFromDom();
      return;
    }

    let finished = false;
    let ends = 0;
    let fallbackId;

    const done = () => {
      if (finished) return;
      finished = true;
      window.clearTimeout(fallbackId);
      this.element.removeEventListener("animationend", onAnimationEnd);
      this.#removeFromDom();
    };

    const onAnimationEnd = (event) => {
      if (event.target !== backdrop && event.target !== dialog) return;
      ends += 1;
      if (ends >= 2) done();
    };

    backdrop.classList.replace("turbo-modal-backdrop-enter", "turbo-modal-backdrop-leave");
    dialog.classList.replace("turbo-modal-dialog-enter", "turbo-modal-dialog-leave");

    this.element.addEventListener("animationend", onAnimationEnd);
    fallbackId = window.setTimeout(() => done(), this.constructor.LEAVE_FALLBACK_MS);
  }

  submitEnd(e) {
    if (!e.detail.success) return;

    const frame = e.target?.dataset?.turboFrame;
    if (frame && frame !== "_top") {
      if (frame === "modal") return;
      const target = document.getElementById(frame);
      if (target && this.element.contains(target)) return;
    }

    this.hideModal();
  }

  #removeFromDom() {
    this.element.parentElement?.removeAttribute("src");
    this.element.remove();
  }
}
